import React, { useState } from "react";
import { Formik, Form, Field, input, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col } from "antd";
import { Switch } from "antd";
import { useNavigate } from "react-router-dom";

import { API_CREATE_MAIN_LAUNDRY } from "api/main-laundry-management";
import { CONSTANTS } from "config/constant";
import { API_CREATE_ROLE } from "api/role-management";
import { API_CREATE_CATAGORY } from "api/catagory-managemnt";
import { useTranslation } from "react-i18next";
import { MdOutlineArrowBack } from "react-icons/md";

const CreateCatagory = () => {
  const { t } = useTranslation();
  const Navigate = useNavigate();

  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              title: "",
              description: "",
            }}
            validationSchema={Yup.object({
              title: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
              description: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
            })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              console.log("values", values);
              try {
                const userData = await API_CREATE_CATAGORY(values);

                toast.success(userData?.message);
                Navigate("/admin/catagory/catagory-tables");
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.errors?.name);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                <div>
                  <div
                    className="flex cursor-pointer items-center gap-2 mb-5"
                    onClick={() => {
                      Navigate(-1);
                    }}
                  >
                    <MdOutlineArrowBack
                      className="cursor-pointer"
                      style={{ fontSize: "17px" }}
                    />
                    <p>Back</p>
                  </div>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <div className="mb-3 mt-9">
                        <label className="font-semibold">
                          {" "}
                          {t("Catagory Name")}
                          <span className="text-[red]">*</span>
                        </label>
                        <Field
                          className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                          type="text"
                          name="title"
                          placeholder={t("Catagory Name")}
                          maxLength={20}
                          onKeyPress={(event) => {
                            const charCode = event.charCode;
                            if (
                              !(charCode >= 65 && charCode <= 90) && // A-Z
                              !(charCode >= 97 && charCode <= 122) && // a-z
                              charCode !== 32 // space
                            ) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <ErrorMessage
                          name="title"
                          component="div"
                          className="text-red-500"
                        />
                      </div>
                    </Col>

                    <Col span={12}>
                      <div className="mb-3 mt-9">
                        <label className="font-semibold">
                          {" "}
                          {t("Catagory Description")}
                          <span className="text-[red]">*</span>
                        </label>
                        <Field
                          className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                          as="textarea"
                          name="description"
                          placeholder={t("Catagory Description")}
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="text-red-500"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {/* {isSubmitting ? "Creating..." : " Create Catagory"} */}
                    {isSubmitting
                      ? t("Creating") + "..."
                      : t("Create Catagory")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default CreateCatagory;
